import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[programStatus]'
})

export class ProgramStatusDirective {

  constructor(el: ElementRef, renderer: Renderer) {
    renderer.setElementStyle(el.nativeElement, 'backgroundColor', 'yellow');
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/status.directive.ts